import React, { FC, useState } from 'react';
import { SCUIButton, SCUITabs, SCUINoRecordComponent } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBillingServiceDrawerContent, SCUIBillingAddToListModal } from './components';
import {
    SCUIGeneralDrawer,
    SCUICustomDataGrid,
    SCUITextFieldWithButton,
    SCUIBreadCrumb,
} from '../../../atomic/molecules';
import { BillingCommand } from '../../../services/command';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { IconButton, Menu, MenuItem, Grid, Chip, Box } from '@mui/material';
import Helper from '../../../utils/helper';

export const BillingService: FC<any> = () => {
    const backofficeUrl = Helper.getBackofficeUrl();

    const { t } = useTranslation();
    const [listModalOpen, setListModalOpen] = useState(false);
    const [billingServiceID, setBillingServiceID] = useState<any>();
    const [orderNo, setOrderNo] = useState('');
    const [datas, setDatas] = React.useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [documentTypeText, setDocumentTypeText] = useState<string>(t('billingServiceLog.eArchive') as string);
    const [visibleResendButton, setVisibleResendButton] = useState(false);
    const [selectedDocumentTypeText, setSelectedDocumentTypeText] = useState<string>(
        t('billingServiceLog.eArchive') as string
    );
    const handleCloseModal = () => {
        setListModalOpen(false);
    };
    const handleShowBill = (item: any) => {
        setBillingServiceID(item.shippmentId);
        onDrawerOpen();
    };
    const [tabIndex, setTabIndex] = useState<any>(1);
    const enumNotificationTabsIndexTabs = [
        { id: 1, name: t('billingServiceLog.eArchive') },
        { id: 6, name: t('billingServiceLog.eInvoice') },
        { id: 8, name: t('billingServiceLog.eDispatch') },
    ];
    const _onChangeTabs = (event: any, activeTabIndex: any): void => {
        setDocumentTypeText(event.target.innerText);
        setTabIndex(activeTabIndex);
    };
    const deleteBill = (deleteBillingInformationType: number, shippmentId: any) => {
        let parameter: any = {};
        parameter.shippingListId = shippmentId;
        parameter.documentType = tabIndex;
        parameter.deleteBillingInformationType = deleteBillingInformationType;

        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.delete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                BillingCommand.DeleteBillingInformation(parameter).then(() => {
                    failedInvoiceList();
                    Swal.fire(t('general.deleted'), ' ', 'success');
                });
            }
        });
    };

    const failedInvoiceList = () => {
        setSelectedDocumentTypeText(documentTypeText);
        let params: any = {};
        params.documentType = tabIndex;
        params.getBillingInformationType = 4;
        params.referenceId = 0;
        BillingCommand.PostGetBillingInformation(params).then((res: any) => {
            if (res.data) {
                setDatas(
                    JSON.parse(res.data).map(function (value: any, idx: any) {
                        return { id: idx, shippmentId: value, failed: true };
                    })
                );
                setVisibleResendButton(true);
            } else {
                setVisibleResendButton(false);
                setDatas([]);
            }
        });
    };

    const listele = async () => {
        setSelectedDocumentTypeText(documentTypeText);
        if (orderNo.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            let tempArr: any = [];

            orderNo
                .trim()
                .split('\n')
                .forEach((item: any, idx: number) => {
                    let my_json = { id: idx, shippmentId: item, state: false };
                    if (item.trim().length > 0) {
                        tempArr.push(my_json);
                    }
                });

            setDatas(tempArr);
            setVisibleResendButton(false);
            handleCloseModal();
        }
    };

    const reSend = async () => {
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.documentType = tabIndex;
                params.updateBillingInformationType = 1;
                BillingCommand.UpdateBillingInformation(params).then((res: any) => {
                    if (res && res.isSucceeded) {
                        Swal.fire(t('general.recordUpdated') + res.result, ' ', 'success');
                        failedInvoiceList();
                    } else {
                        Swal.fire(res.errorMessage, ' ', 'error');
                    }
                });
            }
        });
    };
    return (
        <SCUIContent>
            <SCUIBillingAddToListModal
                open={listModalOpen}
                onClose={handleCloseModal}
                orderNo={orderNo}
                setOrderNo={setOrderNo}
                listele={listele}
            />
            <SCUIGeneralDrawer
                open={drawerOpen}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                <SCUIBillingServiceDrawerContent
                    id={billingServiceID}
                    documentType={tabIndex}
                    onClose={onDrawerClose}
                />
            </SCUIGeneralDrawer>
            <Box className="billing-service">
                <Grid
                    className="billing-service-header"
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem', marginBottom: '16px' }}
                >
                    <SCUIBreadCrumb title={t('dashboard.billingServiceLog')} componentLink={'billingService'} />
                    <Grid
                        className="billing-service-tabs"
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUITabs
                            tabList={Object.values(enumNotificationTabsIndexTabs)}
                            onChange={_onChangeTabs}
                            activeTabIndex={tabIndex}
                        ></SCUITabs>{' '}
                    </Grid>
                    <Grid container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="billing-service-shipping-id-search"
                            size={{
                                sm: 12,
                                md: 4,
                                lg: 4,
                                xl: 4,
                            }}
                        >
                            <SCUITextFieldWithButton
                                placeholder={t('general.shippingID')}
                                onChange={(event: any) => {
                                    setOrderNo(event.target.value);
                                }}
                                onClick={() => listele()}
                                onKeyPress={(e: any) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        listele();
                                    }
                                }}
                            />
                        </Grid>
                        <Grid
                            className="billing-service-header-actions"
                            size={{
                                md: 4,
                                lg: 4,
                                xl: 4,
                            }}
                            sx={{ marginLeft: '16px', display: 'flex', flexDirection: 'row', gap: '16px' }}
                        >
                            <SCUIButton
                                className="billing-service-batch-search-button"
                                text={t('general.batchSearch')}
                                type="secondary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => setListModalOpen(true)}
                            />
                            <SCUIButton
                                className="billing-service-get-failed-invoice-button"
                                text={t('billingServiceLog.getFailedInvoice')}
                                type="primary"
                                style={{ marginLeft: '16px' }}
                                sizeType="fixed"
                                size={'m'}
                                onClick={failedInvoiceList}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {datas ? (
                    <Grid className="billing-service-results" direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="billing-service-results-title"
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 9,
                                lg: 9,
                                md: 6,
                                xs: 6,
                            }}
                        >
                            <h1 className="headtxt">{t('general.searchResults')}</h1>
                        </Grid>
                        <Grid
                            className="billing-service-resend-all"
                            size={{
                                xs: 3,
                                md: 3,
                                lg: 2,
                                xl: 2,
                            }}
                        >
                            {visibleResendButton && (
                                <SCUIButton
                                    className="billing-service-resend-all-button"
                                    text={t('general.reSend')}
                                    type="ghost"
                                    sizeType="fixed"
                                    size={'m'}
                                    onClick={reSend}
                                />
                            )}
                        </Grid>

                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Box className="billing-service-data-grid" sx={{ width: '100%' }}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={datas}
                                    columns={[
                                        {
                                            field: 'shippmentId',
                                            headerName: t('general.shippingID'),
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <a
                                                        className="billing-service-shipping-id-link"
                                                        target="_blank"
                                                        href={
                                                            backofficeUrl +
                                                            'ShippingListDetail.aspx?ShippingListId=' +
                                                            params.row.shippmentId
                                                        }
                                                        rel="noopener noreferrer"
                                                    >
                                                        {params.row.shippmentId}
                                                    </a>
                                                );
                                            },
                                        },
                                        {
                                            field: 'documentType',
                                            headerName: t('billingServiceLog.documentType'),
                                            flex: 1,
                                            renderCell: () => {
                                                return (
                                                    <Chip
                                                        className="billing-service-document-type-chip"
                                                        label={selectedDocumentTypeText as string}
                                                        variant="outlined"
                                                    />
                                                );
                                            },
                                        },
                                        {
                                            field: 'failedInvoice',
                                            headerName: '',
                                            minWidth: 200,
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    params.row.failed && (
                                                        <Chip
                                                            className="billing-service-failed-invoice-chip"
                                                            label={t('billingServiceLog.failedInvoice')}
                                                            color="error"
                                                        />
                                                    )
                                                );
                                            },
                                        },
                                        {
                                            field: 'show',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <p
                                                        className="cursorPointer billing-service-show-link"
                                                        onClick={() => handleShowBill(params.row)}
                                                    >
                                                        {t('general.show')}
                                                    </p>
                                                );
                                            },
                                        },
                                        {
                                            field: 'delete',
                                            headerName: '',
                                            align: 'center',
                                            headerAlign: 'center',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                const handleClick = (popupState: any, tur: string) => {
                                                    popupState.close();
                                                    switch (tur) {
                                                        case 'logDelete': {
                                                            deleteBill(1, params.row.shippmentId);
                                                            break;
                                                        }
                                                        case 'dataLogDelete': {
                                                            deleteBill(2, params.row.shippmentId);
                                                            break;
                                                        }
                                                        default: {
                                                            break;
                                                        }
                                                    }
                                                };
                                                return (
                                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                                        {(popupState: any) => (
                                                            <React.Fragment>
                                                                <IconButton
                                                                    className="billing-service-delete-menu-trigger"
                                                                    {...bindTrigger(popupState)}
                                                                >
                                                                    <p className="cursorPointer billing-service-delete-label">
                                                                        {' '}
                                                                        {t('general.delete')}
                                                                    </p>
                                                                </IconButton>
                                                                <Menu
                                                                    className="billing-service-delete-menu"
                                                                    {...bindMenu(popupState)}
                                                                >
                                                                    <MenuItem
                                                                        className="billing-service-delete-menu-item-log"
                                                                        onClick={() =>
                                                                            handleClick(popupState, 'logDelete')
                                                                        }
                                                                    >
                                                                        {' '}
                                                                        {t('billingServiceLog.logDelete')}
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                        className="billing-service-delete-menu-item-data-log"
                                                                        onClick={() =>
                                                                            handleClick(popupState, 'dataLogDelete')
                                                                        }
                                                                    >
                                                                        {t('billingServiceLog.dataLogDelete')}
                                                                    </MenuItem>
                                                                </Menu>
                                                            </React.Fragment>
                                                        )}
                                                    </PopupState>
                                                );
                                            },
                                        },
                                    ]}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <Box className="billing-service-empty-state" sx={{ marginTop: '24px' }}>
                        <SCUINoRecordComponent />
                    </Box>
                )}
            </Box>
        </SCUIContent>
    );
};
